export default __webpack_public_path__ + "static/texting2-21a09401c8c5b0b51d2346bbc12d7402.mp4";